var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#109B32",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.452 6.735V7.77C23.461 8.062 25 9.725 25 12.714v8.27C25 24.312 23.104 26 19.374 26h-6.748C8.896 26 7 24.31 7 20.985v-8.27c0-1.99.678-3.415 2.07-4.246.219-.15.503-.16.732-.027a.71.71 0 0 1 .35.655.707.707 0 0 1-.422.61c-.921.548-1.356 1.504-1.356 3.007v.266H21.06c.38 0 .687.313.687.699a.693.693 0 0 1-.687.698H8.374v6.608c0 2.538 1.235 3.59 4.252 3.609h6.748c2.974 0 4.243-1.08 4.243-3.618v-8.27c0-2.212-.965-3.282-3.165-3.538v.672a.7.7 0 0 1-.715.606.701.701 0 0 1-.667-.66V6.674a.704.704 0 0 1 .222-.49.68.68 0 0 1 .5-.182.712.712 0 0 1 .66.734Zm-7.743 3.558a.68.68 0 0 1-.492.201.694.694 0 0 1-.67-.707V6.735a.7.7 0 0 1 .692-.629.7.7 0 0 1 .691.63v.963h3.93c.38 0 .688.313.688.699a.693.693 0 0 1-.687.699h-3.948v.699a.704.704 0 0 1-.204.497Zm7.482 6.322c-.48 0-.87.396-.87.885 0 .488.39.884.87.884s.87-.396.87-.884a.892.892 0 0 0-.258-.629.862.862 0 0 0-.62-.256h.008Zm-5.043.885c0-.489.39-.885.87-.885s.869.396.869.885c0 .488-.39.884-.87.884a.877.877 0 0 1-.87-.884Zm-3.296-.885c-.48 0-.87.396-.87.885 0 .488.39.884.87.884s.87-.396.87-.884a.892.892 0 0 0-.258-.629.862.862 0 0 0-.62-.256h.008Zm7.47 4.467c0-.489.39-.884.87-.884h-.01a.862.862 0 0 1 .621.255.892.892 0 0 1 .258.629c0 .489-.39.885-.87.885a.877.877 0 0 1-.87-.885Zm-3.305-.884c-.48 0-.87.395-.87.884s.39.885.87.885.87-.396.87-.885a.877.877 0 0 0-.87-.884Zm-5.034.884c0-.489.389-.884.87-.884h-.01a.862.862 0 0 1 .621.255.892.892 0 0 1 .258.629c0 .489-.39.885-.87.885a.877.877 0 0 1-.87-.885Z",
    fill: "#139C33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.ac37887d49ddabd160da01dcdc2505b6.svg";
export { ForwardRef as ReactComponent };